$(document).ready(function () {
/* before-after slider css start */
new Swiper(".mainSlider", {
    loop: true,
    noSwiping: true,
    centeredSlides: false,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination-parent',
        clickable: true,
      },
      navigation: {
        nextEl: ".mainSlider-button-next",
        prevEl: ".mainSlider-button-prev",
      },
        breakpoints: {
           0: {
              slidesPerView: 1,
           },
           480: {
              slidesPerView: 2,
           },
           991: {
              slidesPerView: 3,
           } 
        }
});

new Swiper(".main-child-slider", {
    loop: true,
    slidesPerView: 1,
     effect: 'fade',
    fadeEffect: { crossFade: true },
     pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    autoplay: {
		delay: 2000,
	 },
	speed: 2000,
  
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
/* before-after slider css end */

/* product description css start */ 
$('.readmore').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'block';window.scrollTo({top: 110, behavior: 'smooth'});
});
/* product description css end */

  /* imgfaq js start */
     // $(".accordian_contains").hide();
     $(".accordion_in_flxs").click(function() {
        var $currentAccordion = $(this).next(".accordian_contains");
        var $currentIcons = $(this).find(".accordion_in_icons svg");

        // Slide up all visible accordions
        $(".accordian_contains").not($currentAccordion).slideUp(300);
        // Hide minus icons and show plus icons for all accordions
        $(".accordion_in_icons svg.minus_icon").not($currentIcons).hide();
        $(".accordion_in_icons svg.plus_icon").not($currentIcons).show();

        // Toggle current accordion
        if ($currentAccordion.is(":visible")) {
            $currentAccordion.slideUp(300);
            $currentIcons.filter(".minus_icon").hide();
            $currentIcons.filter(".plus_icon").show();
        } else {
            $currentAccordion.slideDown(300);
            $currentIcons.filter(".minus_icon").show();
            $currentIcons.filter(".plus_icon").hide();
        }

        // Remove 'colored_text' class from all and add to current
        $('.accordion_in_flxs').removeClass('colored_text');
        $(this).addClass('colored_text');
    });
/* imgfaq js start */
  
  /* faq-search js start */
    $(".search__input").on("keyup", function() {
        var searchString = $(this).val();
        $(document).find(".faq_searching_content").each(function(index, value) {
            console.log(value);
            var currentName = $(value).text();
            // currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1 ? $(value).show() : $(value).hide() 
            if(currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1){
              $(value).show();
              // $(value).parents('.faq_section_outer').find('.faq_section_heading').show();
            }
            else{
              $(value).hide() 
              // $(value).parents('.faq_section_outer').find('.faq_section_heading').hide();
            }
          
        });
    });
  /* faq-search js end */

  // before/after js starts

    $('.img-col a .search_icon').click(function (e) {

      $('.all_images_main_swiper').remove();
      
      e.preventDefault();
      var singleImageContainer ;
      
      $('<div class="all_images_main_swiper"><div class="all_img_container swiper-wrapper"></div></div>').appendTo('.image-with-slider') ;

      $('.all_images_main_swiper').append('<div class="all-images-swiper-button-prev all-images-swiper-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z"/></svg></div><div class="all-images-swiper-button-next all-images-swiper-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"/></svg></div>');

      $('.all_images_main_swiper').append('<span class="cross_icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></span>')

      $(this).parents('.main-child-slider').find('.swiper-wrapper .swiper-slide.slide_col .img-col').each(function (index,value) {
        singleImageContainer = $('<div class="single_img_container swiper-slide"><div class="image_and_para"><img src='+ $(value).find('a img').attr('src') +'><p>' + $(value).find("p").text() + '</p></div></div>') ;
        $(".all_img_container").append(singleImageContainer) ;           
      }) ;

        const swiper = new Swiper('.all_images_main_swiper', {
          direction: 'horizontal',
          loop: true,
          navigation: {
            nextEl: '.all-images-swiper-button-next',
            prevEl: '.all-images-swiper-button-prev',
          }      
        });
      
         $('.all_images_main_swiper .cross_icon svg').click(function () {
           $('.all_images_main_swiper').remove();
       });
      
    });
  
    // before/after js ends

$('.productGrid').hide();
$('.productGrid:first').show();
$('.collection-names ul li:first').addClass('active');
$('.collection-names ul li').click(function(){
  $('.productGrid').hide();
  $('.collection-names ul li').removeClass('active');
  $(this).addClass('active');
  var activeTab = $(this).attr('data-collection-name');
  $('.productGrid').each(function(){
    var tab  = $(this).attr('data-collection-id');
    if(activeTab == tab ){
      $(this).fadeIn();
    }
  })
  return false;    
}); 

  $('.categories_part_top .button').click(function(){
    $(this).toggleClass('active');
    $('.categories_part_top .categories_part').toggleClass('hidden');
  });


  /* bundle js start */

// $(document).on('click', '.submit-btn', function(event) {
//     event.preventDefault(); 
//     const $button = $(this); 
//     const selectVariantId = $button.attr('data-id');

//     if (!selectVariantId) {
//         console.warn("No variant ID found.");
//         return;
//     }

//     const items = [{
//         id: selectVariantId,
//         quantity: 1 
//     }];

//     const cartData = {
//         items: items
//     };
//     console.log(cartData);

//     $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         dataType: "json",
//         contentType: "application/json", 
//         data: JSON.stringify(cartData),
//         success: function(data) {
//             console.log("Add to cart success:", data);
//             window.location.href = "/cart"; 
//         },
//         error: function(xhr, status, error) {
//             console.error("Add to cart Error:", error);
//             console.error("Response Text:", xhr.responseText);
//             console.log("There was an error adding items to the cart. Please try again."); 
//         }
//     });
// });


  $(document).on('click', '.submit-btn', function(event) {
    event.preventDefault();
    
    const $button = $(this);
    const selectVariantId = $button.attr('data-id');
    const availableQuantity = parseInt($button.attr('data-quant'), 10);
    
    if (!selectVariantId) {
        console.warn("No variant ID found.");
        return;
    }

    // Hide the error message initially
    $('.error_msg').hide();
    
    // Fetch current cart contents
    $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function(cartData) {
            const currentQuantity = cartData.items.reduce((acc, item) => {
                if (item.id == selectVariantId) {
                    return acc + item.quantity;
                }
                return acc;
            }, 0);

            const totalQuantity = currentQuantity + 1; // Adding 1 for the new item
            
            // Check if the total quantity exceeds available quantity
            if (totalQuantity > availableQuantity) {
                // Show error message
                $('.error_msg').fadeIn();
              // Hide the error message after 3 seconds
                setTimeout(function() {
                    $('.error_msg').fadeOut();
                }, 3000); 

                return;
            }

            // If quantity is sufficient, proceed to add to cart
            const items = [{
                id: selectVariantId,
                quantity: 1 
            }];

            const newCartData = {
                items: items
            };
            console.log(newCartData);

            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                contentType: "application/json", 
                data: JSON.stringify(newCartData),
                success: function(data) {
                    console.log("Add to cart success:", data);
                    window.location.href = "/cart"; 
                },
                error: function(xhr, status, error) {
                    $('.error_msg').show();
                    console.error("Add to cart Error:", error);
                    console.error("Response Text:", xhr.responseText);
                    //alert("There was an error adding items to the cart. Please try again."); 
                }
            });
        },
        error: function(xhr, status, error) {
            $('.error_msg').show();
            console.error("Error fetching cart data:", error);
            //alert("There was an error fetching the cart. Please try again.");
        }
    });
});


  // Select all copy buttons
const copyButtons = document.querySelectorAll('.copybtn');

copyButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const copyButtonBlock = button.parentElement; 
        const input = copyButtonBlock.previousElementSibling;
        const icon = button.nextElementSibling; 

        if (input && input.classList.contains('copyvalue')) {
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand('copy');

            button.textContent = 'Copied!';
            if (icon) icon.style.display = 'inline';

            setTimeout(() => {
                button.textContent = 'COPY';
                if (icon) icon.style.display = 'none';
            }, 2000);
        }
    });
});




  
});












